let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eRqqW")).then(() => parcelRequire('auMmF'));